import React, { useEffect, useState } from "react";
import MenuLayouts from "../layouts/menu.layout";
import BtnFloatingLayout from "../layouts/btn_flotante.layout";
import FooterLayouts from "../layouts/footer.layout";
import BannerComponent from "../components/politicas_proteccion_datos/banner.component";
import TitleComponent from "../components/politicas_proteccion_datos/title.component";
import DescriptionComponent from "../components/politicas_proteccion_datos/description.component";
import { politicasProteccionDatos } from "../components/conexion/politica.conexion";

const PoliticasProteccionDatosPage: React.FC = () => {
  const [visibleHeight, setVisibleHeight] = useState(0);
  const [politicas, setPoliticas]: any = useState([]);

  useEffect(() => {
    politicasProteccionDatos().then(function (res: any) {
      setPoliticas(res?.data?.data[0]);
    });
  }, []);

  return (
    <>
      <MenuLayouts
        className="home-page"
        active=""
        setVisibleHeight={setVisibleHeight}
        visibleHeight={visibleHeight}
      />
      <div className="home-page">
        <h1
          style={{ position: "absolute", opacity: "0", pointerEvents: "none" }}
        >
          Políticas de Protección de Datos - Hyundai Colombia
        </h1>

        <div className="home-page-mascara"></div>
        <BannerComponent />
        <TitleComponent />
        <DescriptionComponent politicas={politicas} />
      </div>
      <BtnFloatingLayout reserva="https://reservas.hyundaicolombia.co/" />
      <FooterLayouts />
    </>
  );
};

export default PoliticasProteccionDatosPage;
